import PrimaryButton from '@components/atoms/buttons/PrimaryButton';
import FormField from '@components/atoms/FormField';
import BREAKPOINTS from '@lib/constants/breakpoints';
import ROUTES from '@lib/constants/routes';
import { useRouter } from 'next/router';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import styled from 'styled-components';

const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;
  align-items: center;

  max-width: 600px;

  @media screen and (max-width: ${BREAKPOINTS.medium}) {
    grid-template-columns: 1fr;

    button {
      width: 100%;
    }
  }
`;

const CompareStatsForm = ({
  stats,
  modelA,
}: {
  stats: any[];
  modelA?: { modelName: string; brandName: string; model: string };
}) => {
  const router = useRouter();
  const { handleSubmit, control } = useForm<{
    modelA: { value: string };
    modelB: { value: string };
  }>();

  const options = stats.map((s) => ({
    value: s.model,
    label: `${s.brandName} ${s.modelName}`,
  }));

  return (
    <Form
      onSubmit={handleSubmit((data) => {
        router.push(ROUTES.compareModels(data.modelA.value, data.modelB.value));
      })}
    >

      <FormField style={{ width: '100%' }} label="Modelo A">
        <Controller
          name="modelA"
          control={control}
          rules={{ required: 'Escolha um modelo' }}
          defaultValue={
                modelA && { label: modelA.modelName, value: modelA.model }
              }
          render={(field) => (
            <Select
              {...field}
              noOptionsMessage={() => 'Não encontrado'}
              options={options}
              isDisabled={!!modelA}
              placeholder="Escolha uma moto"
            />
          )}
        />
      </FormField>

      <FormField style={{ width: '100%' }} label="Modelo B">
        <Controller
          name="modelB"
          control={control}
          rules={{ required: 'Escolha um modelo' }}
          defaultValue={undefined}
          render={(field) => (
            <Select
              {...field}
              noOptionsMessage={() => 'Não encontrado'}
              options={options}
              placeholder="Escolha uma moto"
            />
          )}
        />
      </FormField>

      <PrimaryButton pink>Comparar</PrimaryButton>

    </Form>
  );
};

export default CompareStatsForm;
